import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import APIBase from "../lib/apiBase";
import { consumeGoogleAuthCode } from "../lib/authLib";

const OAuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleAuth = async () => {
      const params = new URLSearchParams(location.search);
      const code = params.get("code");

      if (!code) {
        setError("No authentication code found.");
        return;
      }

      const isPopup = !!window.opener;

      if (isPopup) {
        try {
          const { data } = await APIBase.get(`/auth/google/callback`, {
            params: {
              code,
              redirect_uri: process.env.REACT_APP_DASHBOARD_OAUTH_CALLBACK_URI,
              intent: "reauth",
            },
          });

          window.opener.postMessage(
            {
              type: "cobutler-reauth-success",
              payload: {
                inboxId: data.inbox?.id,
                email: data.inbox?.email,
              },
            },
            window.location.origin
          );
          window.close();
        } catch (err) {
          window.opener.postMessage(
            {
              type: "cobutler-reauth-error",
              error: "Authentication failed",
            },
            window.location.origin
          );
          window.close();
        }
      } else {
        try {
          await consumeGoogleAuthCode(code);
          window.location.href = "/";
        } catch (error) {
          setError("Authentication failed. Please try again.");
        }
      }
    };

    handleAuth();
  }, [location, navigate]);

  return (
    <div className="flex justify-center items-center h-screen">
      {error ? (
        <p className="text-red-500">
          {error}{" "}
          <a href="/login" className="text-blue-500 hover:text-blue-700">
            return to login
          </a>
        </p>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
};

export default OAuthCallback;
